import { lazy } from 'react';

const TextModule = lazy(() => import('../components/TextModule'));
const PhotoStoryModule = lazy(() => import('../components/PhotoStoryModule'));
const NewVoicePostcard = lazy(() => import('../components/NewVoicePostcard'));
const GuestbookModule = lazy(() => import('../components/GuestbookModule'));
const KeepsakePosterModule = lazy(() => import('../components/KeepsakePosterModule'));
const OpenWhenModule = lazy(() => import('../components/OpenWhenModule'));

const CORE_MODULE_COMPONENTS = {
  primary_media: PhotoStoryModule,
  primaryMedia: PhotoStoryModule,
  text: TextModule,
  surprise_box: OpenWhenModule,
  voice_postcard: NewVoicePostcard,
  guestbook: GuestbookModule,
  keepsake_poster: KeepsakePosterModule,
};

export default CORE_MODULE_COMPONENTS;
